import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectImage12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMediaObjectImage12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.5 2h-4a.5.5 0 0 0-.5.5v4.793l.646-.647.267-.266.33.183L6 8.65V2.5a.5.5 0 0 0-.5-.5m.43 7.755L2.087 7.62 1 8.707V9.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .43-.245M1.5 1A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h4A1.5 1.5 0 0 0 7 9.5v-7A1.5 1.5 0 0 0 5.5 1zm7 2.5A.5.5 0 0 1 9 3h2.5a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M9 5a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 0-1zM3.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectImage12);
